import React from 'react';
import { useState, useRef, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import RoleUtil from '../util/RoleUtil';
import { Link, useNavigate } from 'react-router-dom';
import { VIEWS } from '../constant/ViewConstant';
import { MAIN_PATH } from '../constant/Constant';
import { useSelector } from 'react-redux';
import AuthenticationUtil from '../util/AuthenticationUtil';

const MenuButton = ({ userRoleCd, view }) => {
    const navigate = useNavigate();
    const subMenus = [];
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = (open) => {
        setOpen(!open);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleClickMenu = (event, url) => {
        navigate(url);
        handleClose(event);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    for (let [k, v] of view.views) {
        if (v.isMenu && RoleUtil.checkRole(v.privilege, userRoleCd)) {
            subMenus.push(v);
        }
    }

    // z-index 처리
    return (
        <div key={view.path}>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup='true'
                onClick={(e) => handleToggle(open)}
            >
                <div className='menu-title'>{view.title}</div>
            </Button>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                style={{ zIndex: 1 }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id='menu-list-grow' onKeyDown={handleListKeyDown}>
                                    {subMenus.map((subView) => (
                                        <MenuItem
                                            key={subView.pathKey}
                                            onClick={(event) => handleClickMenu(event, subView.path)}
                                        >
                                            {/* <Link to={subView.path}>{subView.title}</Link> */}
                                            {subView.title}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
};

const HeaderMain = ({ webType }) => {
    const { logged } = useSelector((state) => state.loginState);
    const [userRoleCd, setUserRoleCd] = useState('');
    const [menus, setMenus] = useState([]);

    useEffect(() => {
        setUserRoleCd(AuthenticationUtil.getUserRoleCd());
    }, [logged]);

    useEffect(() => {
        const menus = [];
        for (let [k, v] of VIEWS.views) {
            if (v.isMenu && RoleUtil.checkRole(v.privilege, userRoleCd)) {
                menus.push(v);
            }
        }
        setMenus(menus);
    }, [userRoleCd]);

    // student teacher
    return (
        // <div className={`header-main ${webType}`}>
        <div className='header-main'>
            <div className='header-main-inner'>
                <div className='gnb-left'>
                    <h1>
                        <Link to={MAIN_PATH} className='main-logo'>
                            <span className='logo'></span>
                            <span className='main-tit'>
                                <span>첨단분야 혁신융합대학사업(미래자동차)</span>
                                <span className='tit-sm'>수강신청지원시스템</span>
                            </span>
                        </Link>
                    </h1>
                </div>
                <div className='gnb-right'>
                    <div className='gnb-menu'>
                        {menus.map((view, index) => (
                            <div key={index} className='menu-list'>
                                <MenuButton key={view.pathKey} userRoleCd={userRoleCd} view={view} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderMain;
